import Vue from "vue";

Vue.prototype.$plantare = [
  { key: "thick_cen_heel" },
  { key: "thick_pla" },
  { key: "thick_poi" },
  { key: "pla_til_heel" },
  { key: "pla_til_poi" },
  { key: "height_col_med" },
  { key: "height_col_lat" }
];
